<template>
  <div class="popUpMain">
    <div class="popUpLeft">
      <div class="popUpTop">
        <div class="popUpTopCtrlMain">
          <Input class="popUpTopInput" placeholder="Job No" :inputValue.sync="data.deliveryJobNo" />
          <div class="tableCtrlMain">
            <DateTimePicker class="tableCtrl" :showTime="false" :value.sync="fromDatePicker" title="Start" />
            <DateTimePicker class="tableCtrl" :showTime="false" :value.sync="toDatePicker" title="End" />
            <button class="tableCtrlBtn" @click="btnClicked('refresh')"> Refresh </button> 
          </div>
        </div>
      </div>
      <div class="popUpBottom">
        <div class="tableMain"> 
          <TableBox class="jobsTabulator" tableTitle="List" tableID="jobsTable" :tableData="tabData" :selectedRow.sync="selectedRow" 
            multiSelect="1" />
        </div>
      </div>
    </div>
    <div class="popUpRight">
      <button class="popUpTopCtrl" @click="btnClicked('next')" :disabled="data.deliveryJobNo ? false : true"> Next </button>
    </div>
    
    <Loader :isVisible="loading" :loadingText="loadingText"/>
  </div>
</template>

<script>
/* eslint-disable */
import Input from '@/components/Input.vue';
// import DateTimePicker from '@/components/DateTimePicker.vue';
import Tabulator from '@/components/Tabulator.vue';
import Loader from '@/components/Loader.vue';

export default {
  components: {
    Input, Tabulator, Loader,
  },
  data: function() {
    return {
    }
  },
  props: {
    data: { type: Object, default: function () { return {} } },
    viewMode: { type: Boolean, default: false },

    loading: { type: Boolean, default: false },
    loadingText: { type: String, default: '' },

    //dateNow: { type: String, default: this.$dateTime.getDateTime(new Date(), 'yyyy-MM-dd')  },
    fromDate: { type: Date, default: null },
    toDate: { type: Date, default: null },
    fromDatePicker: { type: Date, default: new Date(2020, 0, 1) },
    toDatePicker: { type: Date, default: new Date(2020, 5, 0) },
    refreshDate: { type: Date, default: new Date() }, 

    selectedRow: { type: Array, default: function () { return []; } }, //Selected row on table
    tabData: { type: Array, default: function () { return []; } },

    jobMsg: { type: Array, default: function () { return []; } },
  },
  methods: {
    btnClicked: async function (btn) {
      switch (btn) {
        case 'refresh':
          this.data.jobMsg = [];
          await this.getData();
          console.log(this.tabData);
          if (this.tabData.length < 1) {
            this.data.jobMsg = ['Please change your date selection and click \'Refresh\' button to retrieve the job list.'];
          } else {
            this.data.jobMsg = ['Please input or select a Job No.'];
          }
          break;
        case 'next':
          var foundJob = this.tabData.filter((d) => { return d['Job_No'].trim() == this.data.deliveryJobNo });
          if (this.tabData.length < 1) {
            this.data.jobMsg = ['Please change your date selection and click \'Refresh\' button to retrieve the job list.'];
          } else if (foundJob.length < 1) {
            this.data.jobMsg = ['Please input valid Job No or select from table.'];
          } else {
            this.$bus.$emit('DNJobNew','next');
          }
          break;
      }
    },

    refreshClicked: function() {
      this.getData();
    },

    //DateTime Conversion
    convertDateTime: function (dateString, timeString) {
      var newDate = this.utcToDate(dateString);
      newDate = this.longToShortDate(newDate);

      var newDateTime = newDate.slice(0, 10);
      var time1 = timeString.slice(0, 2);
      var time2 = timeString.slice(2, 4);
      newDateTime = `${newDateTime} ${time1}:${time2}`;
      return newDateTime
    },
    utcToDate: function (dateString) {
      dateString = dateString.replace('/Date(', '');
      dateString = dateString.replace(')/', '');
      var d = new Date(0);
      d.setUTCMilliseconds(dateString);
      return d;
    },
    longToShortDate: function (longDate) {
      var d = longDate.getDate().toString();
      var m = longDate.getMonth() + 1;
      var y = longDate.getFullYear();
      var hh = longDate.getHours().toString();
      var mm = longDate.getMinutes().toString();

      d = (d.length < 2) ? 0 + d : d;
      m = m.toString();
      m = (m.length < 2) ? 0 + m : m;
      hh = (hh.length < 2) ? 0 + hh : hh;
      mm = (mm.length < 2) ? 0 + mm : mm;

      var formattedDate = `${d}/${m}/${y} ${hh}:${mm}`;
      return formattedDate;
    },
		//DateTime Conversions

    mountCurrentDate: function () {
      var dateNow = new Date(this.$dateTime.getDateTime(new Date(), 'yyyy-MM-dd'));
      this.fromDatePicker = dateNow;
      this.toDatePicker = dateNow;
    },
    getData: async function () {
      this.loadingText = 'Getting Jobs List';
      this.loading = true;
      var startString = this.$dateTime.getDateTime(this.fromDatePicker, 'yyyy-MM-dd').toString();
      var endString = this.$dateTime.getDateTime(this.toDatePicker, 'yyyy-MM-dd').toString();
      var receivedJobs = await this.$apiCallV2(`/DeliveryNotes/GetDeliveryNoteJobDetailsList?startdate=${startString}&enddate=${endString}`);
      this.tabData = receivedJobs;
      this.loading = false;
    },
  },
  mounted() {
    this.mountCurrentDate();
    this.getData();
    this.data.jobMsg = ['Please change your date selection and click \'Refresh\' button to retrieve the job list.'];
  },
  watch: {
    selectedRow: function () {
      this.data.deliveryJobNo = this.selectedRow.length > 0 ? this.selectedRow[0].Job_No.trim() : '';
    },
		data: {
			deep: true,
      handler(val) {

			}
		},
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.popUpMain {
    width: 100%;
    height: 100%;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .popUpLeft {
    width: auto;
    height: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }

  .popUpRight {
    width: auto;
    height: 100%;
    padding: 0 3px 0 0;
    margin: 0 0 0 8px;
    display: flex;
    align-items: flex-end;
    justify-content: center;
  }

  .popUpTop {
    width: 100%;
    height: auto;
    padding: 4px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .popUpTopCtrlMain {
    width: auto;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }

  .popUpTopCtrl {
    width: 86px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .popUpBottom {
    width: 100%;
    height: 100%;
    padding: 0 4px;
    display: flex;
    align-items: flex-start;
    justify-content: center;
  }

  /* -- Table CSS -- */
  .tableMain {
    width: auto;
    height: 100%;
    flex: 1;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }

  .jobsTabulator {
    width: auto;
    height: auto;
    position: absolute;
    top: 39px;
    bottom: 38px;
    left: 0px;
    right: 0px;
    background-color: #fff;
  }

  .tableCtrlMain {
    width: 100%;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background-color: #fff;
  }

  .tableCtrl {
    width: 200px;
    height: 100%;
    margin: 0 4px 0 0;
  }

  .tableCtrlBtn {
    width: 80px;
    height: 100%;
    font-size: 12px;
    line-height: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

</style>
